<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline>
      <el-form-item label="银行名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入银行名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="title"
        label="银行名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="url"
        label="银行网址"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            @click="handleCheck(scope.$index, scope.row)">查看</el-button> -->
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <add-or-edit-dialog :show.sync="addOrEditShow" :info="addOrEditInfo" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AddOrEditDialog from './addOrEditDialog'

export default {
  name: 'UploadCenterCooperateBank',
  components: { AddOrEditDialog },
  data () {
    return {
      form: {
        name: ''
      },
      addOrEditShow: false,
      addOrEditInfo: {}
    }
  },
  computed: {
    ...mapGetters({
      list: 'getUploadCenterCooperateBankList',
      listState: 'getUploadCenterCooperateBankListState'
    })
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getUploadCenterCooperateBankList', 'getUploadCenterCooperateBankDetail', 'delUploadCenterCooperateBank']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getUploadCenterCooperateBankList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getUploadCenterCooperateBankList({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getUploadCenterCooperateBankList(params)
    },
    handleAdd () {
      // 打开新增页面
      this.addOrEditInfo = {}
      this.addOrEditShow = true
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    // handleCheck (index, row) {
    //   // 打开查看界面
    // },
    handleEdit (index, row) {
      // 打开编辑界面
      this.addOrEditInfo = row
      this.addOrEditShow = true
    },
    handleDelete (index, row) {
      this.$confirm('确定删除？', '删除提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除接口
        this.delUploadCenterCooperateBank({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.handleSearch()
        })
      }).catch(() => {
        // 取消删除
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
